import type ImageSize from "~/models/image/ImageSize";

const BANNER_DIMENSIONS: ImageSize = {
  width: 1000,
  height: 400,
};

export default BANNER_DIMENSIONS;
